/**
 * HTTP utilities for API communication
 *
 * Provides functions for constructing API URLs based on environment configuration.
 */

import { Environment } from "../types/config";
import {
  TEST_PROJECT_NUMBER,
  PRODUCTION_PROJECT_NUMBER,
  REGION,
} from "../core/constants";

/**
 * Constructs the base API URL for the specified environment
 *
 * @param environment - The target environment (test or production)
 * @returns Base URL template with service name placeholder
 */
export function getBaseUrl(environment: Environment): string {
  const projectNumber =
    environment === "production"
      ? PRODUCTION_PROJECT_NUMBER
      : TEST_PROJECT_NUMBER;
  return `https://sdk-{{service-name}}-${projectNumber}.${REGION}.run.app`;
}
